export default function Container({ children, className }) {
  const addClassName = className ? `${className}` : "";

  return (
    <div className={`container mx-auto md:px-16 px-5 py-4 ${addClassName}`}>
      {children}
    </div>
  );
}
